import React, { useState, useEffect, useMemo } from "react";
import { BsFillBookmarkFill, BsBookmark } from "react-icons/bs";
import { HiOutlineDownload } from "react-icons/hi";
import { IoIosArrowForward } from "react-icons/io";
import {
  AiFillInstagram,
  AiFillTwitterSquare,
  AiFillLinkedin,
} from "react-icons/ai";
import { FaGithubSquare } from "react-icons/fa";
import { saveAs } from "file-saver";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import PostComments from "./postComments";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  setDoc,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebase-config";
import parse from "html-react-parser";
import moment from "moment";
import { UserAuth } from "../context/authContext";

function MiniOther({
  postid,
  ind,
  title,
  tumbnail,
  publishedby,
  category,
  profpic,
  content,
  name,
  datepub,
}) {
  const [bookmarked, setBookmarked] = useState(null);
  const [save, setSave] = useState(null);

  const { user } = UserAuth();

  const checkIfExists = async () => {
    const docRef = doc(db, "users", user.uid, "Bookmarks", postid);

    const snap = await getDoc(docRef);

    if (!snap.exists || snap.data() === undefined) {
      setSave(false);
    } else {
      setSave(true);
    }
  };

  useEffect(() => {
    checkIfExists();
  }, []);

  const handleBookmark = async () => {
    const docRef = doc(db, "users", user.uid, "Bookmarks", postid);

    const getoc = await getDoc(docRef);

    if (bookmarked === true) {
      await setDoc(docRef, {
        postID: postid,
        postCategory: category,
        postPic: tumbnail,
        postPublisher: publishedby,
        name: name,
        profPic: profpic,
        title: title && title,
      });
    } else if (bookmarked === false) {
      if (getoc.exists) {
        await deleteDoc(docRef);

        const dummy = "dummy";

        const deleteDummy = doc(db, "users", user.uid, "Bookmarks", dummy);

        await deleteDoc(deleteDummy);
      }
    }
  };

  useEffect(() => {
    handleBookmark();
  }, [bookmarked]);

  let navigate = useNavigate();

  const routeChange = (titre, identifier) => {
    const nav = `/post/${titre}=${identifier}`;
    navigate(nav);
  };

  const getShortVesr = content ? content.substring(0, 330) + "..." : "";

  const getShortTitle = title ? title.substring(0, 40) + "..." : "";

  return (
    <motion.div
      className="w-[97%] h-[9.3rem] flex flex-row py-2 pl-2 bg-[#181818] rounded-xl hover:cursor-pointer hover:bg-[#141414] transition-all ease-in-out"
      key={ind}
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      transition={{
        ease: "easeIn",
        duration: 0.5,
      }}
      exit={{ opacity: 0 }}
      onLoad={() => {
        checkIfExists(postid);
      }}
    >
      <div
        className="w-[27%] h-full rounded-lg overflow-hidden"
        onClick={() => routeChange(title, postid)}
      >
        <img
          src={tumbnail}
          referrerPolicy="no-referrer"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="w-[73%] flex flex-col px-3 py-1 overflow-hidden justify-between">
        <div className="w-full flex flex-row justify-between items-center">
          <div
            className="text-sm text-OrangyRed"
            onClick={() => routeChange(title, postid)}
          >
            {moment(datepub.toDate()).calendar()}
          </div>
          {bookmarked || save ? (
            <BsFillBookmarkFill
              size={25}
              className="self-center fill-OrangyRed animate-scale"
              onClick={() => {
                handleBookmark();
                setBookmarked(false);
                setSave(false);
              }}
            />
          ) : (
            <BsBookmark
              size={25}
              className="self-center fill-zinc-300 animate-scale"
              onClick={() => {
                handleBookmark();
                setBookmarked(true);
                setSave(true);
              }}
            />
          )}
        </div>
        <div
          className="flex flex-row w-full justify-between"
          onClick={() => routeChange(title, postid)}
        >
          <div className="font-semibold text-zinc-200">{getShortTitle}</div>
        </div>
        <div
          className="w-full text-sm"
          onClick={() => routeChange(title, postid)}
        >
          {parse(getShortVesr)}
        </div>
      </div>
    </motion.div>
  );
}

export default MiniOther;
